/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import {
  InnerBanner,
  IframeVideo,
  BannerDescription,
  BannerHeading,
  BannerP,
} from './styles/InnerPageBanner.styled';
import { Container } from './styles/Container.styled';
import ScrollDownButton from './ScrollDownButton';
import InnerBannerSearchBar from './InnerBannerSearchBar';

export default function InsightsHero({ data }) {
  return (
    <InnerBanner className="video_section">
      <IframeVideo className="video_banner">
        <iframe
          title="video"
          tabIndex="-1"
          src={data.videoUrl}
          className="vm-source"
          width="100%"
          height="100%"
          allowFullScreen=""
          data-deferred="true"
        />
      </IframeVideo>
      <BannerDescription className="description_banner">
        <Container>
          <BannerHeading dir="ltr">{data.title}</BannerHeading>
          <BannerP>{data.description}</BannerP>
          <InnerBannerSearchBar placeholder="What are you interested in?" />
        </Container>
      </BannerDescription>
      <ScrollDownButton position={data.jumpToSection} />
    </InnerBanner>
  );
}
